const initialState = {};

const someReducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default someReducer;
